let onboardingMock = [
    {
        "id": "b0b63c69-675e-429f-9ad0-76d88ece6dc9",
        "name": "first_login",
        "status": "view",
        "steps": [{
            "title": "Erste Schritte",
            "text": "",
            "position": 1
        }]
    },
    {
        "id": "b0b63c69-675e-429f-9ad0-76d88ece6dc9",
        "name": "first_steps",
        "status": "view",
        "steps": [{
            "title": "Benutzer anlegen",
            "text": "Bitte geben Sie hier die persönlichen Informationen und mindestens eine Kontaktmöglichkeit (E-Mail-Adresse oder Mobilfunknummer) eines Benutzers an, der Gefährdungsbeurteilungen erstellen können soll. Weisen Sie dem Benutzer abschließend eine der folgenden Benutzerrollen zu:" + '<br/><br/>' + '<ul><li>' + "Administrator - Kann Gefährdungsbeurteilungen für alle Arbeitsstätten erstellen." + '</li></ul>' + '<ul><li>' + "Benutzer - Kann Gefährdungsbeurteilungen für Arbeitsstätten erstellen, denen er zugewiesen wurde." + '</li></ul>' + '<ul><li>' + "Gast - Kann bestehende Gefährdungsbeurteilungen einsehen, aber keine neuen erstellen." + '</li></ul>',
            "position": 1
        }, {
            "title": "Arbeitsstätten",
            "position": 2
        }, {
            "title": "Gefährdungsbeurteilung",
            "position": 3
        }]
    }
]
module.exports = onboardingMock;